import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var UsersActionType;
(function (UsersActionType) {
    UsersActionType["SET_USERS"] = "set users";
    UsersActionType["SET_USER"] = "set user";
    UsersActionType["CLEAR_USERS"] = "clear users";
})(UsersActionType || (UsersActionType = {}));
export const setUsers = (projectId, users, searchParams) => {
    return {
        type: UsersActionType.SET_USERS,
        projectId,
        usersDataSet: users,
        searchParams,
    };
};
export const setUser = (projectId, user) => {
    return {
        type: UsersActionType.SET_USER,
        projectId,
        user,
    };
};
/**
 * Create an action for setting the current user the agent is looking at
 */
export const clearUsers = (projectId) => {
    return {
        type: UsersActionType.CLEAR_USERS,
        projectId,
    };
};
/**
 * Get all users for the specified project with the specified filters
 * @param projectId - The project id
 * @param search - Filter by the specified 'search' string. Return only users who have email, name, or phone
 *                 that matches the 'search' string
 * @param pageNumber - The page number, used as page number for paging.
 * @param pageSize - The maximum # of users to return if there are more than max
 */
export const fetchFilteredUsers = (projectId, search, pageNumber, pageSize) => {
    return async (dataDispatch) => {
        const usersDataSet = await RitzAPI.getInstance().getFilteredUsers(projectId, search, pageNumber !== undefined && pageSize !== undefined ? pageNumber * pageSize : undefined, pageSize);
        await dataDispatch(setUsers(projectId, usersDataSet, searchParamsToString({
            searchText: search,
            pageNumber,
            pageSize,
        })));
    };
};
/**
 * Get a user profile by his user id
 * @param projectId - The id of the project the user belonged to
 * @param userId - The id of the user to look for
 */
export const fetchFilteredUser = (projectId, userId, pageNumber, pageSize) => {
    return async (dataDispatch) => {
        const usersDataSet = await RitzAPI.getInstance().getFilteredUser(projectId, userId);
        await dataDispatch(setUsers(projectId, usersDataSet, searchParamsToString({
            searchText: userId.toString(),
            pageNumber,
            pageSize,
        })));
    };
};
/**
 * Get a user profile by his user id
 * @param projectId - The id of the project the user belonged to
 * @param userId - The id of the user to look for
 */
export const fetchUserById = (projectId, userId) => {
    return async (dataDispatch) => {
        const user = await RitzAPI.getInstance().getUserById(projectId, userId);
        await dataDispatch(setUser(projectId, user));
    };
};
/**
 * Update the user profile, only user name for now
 * @param userId - The ID of the user we want to update
 * @param name - The name to set for the user
 */
export const updateUser = (userId, name) => {
    return async () => {
        await RitzAPI.getInstance().updateUser(userId, name);
    };
};
/**
 * Create a new user with email as login
 * @param projectId - The id of the project which the user to be created for
 * @param name - The new user name
 * @param email - The new user email
 * @param password - The new user password
 */
export const createUserByEmail = (projectId, name, email, password) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().createUserByEmail(projectId, name, email, password);
        await dataDispatch(clearUsers(projectId));
    };
};
/**
 * Create a new user with phone number as login
 * @param projectId - The id of the project which the user to be created for
 * @param name - The new user name
 * @param phone - The new user phone number
 */
export const createUserByPhone = (projectId, name, phoneNumber) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().createUserByPhone(projectId, name, phoneNumber);
        await dataDispatch(clearUsers(projectId));
    };
};
